module.exports = __webpack_public_path__ + "static/freshfund-2ea104f3d3745b916dfd4f42cc1ec714.png";